import Loadable from '@townsquare/loadable';

export const FollowProjectAction = Loadable({
  loader: () => import(/* webpackChunkName: "FollowProjectAction" */ './FollowProjectAction'),
  loading: () => null,
});

export { followProjectResource } from './resource';
